import { Box } from '@mui/material';
import React from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { getToken } from 'utils/helpers';
import BrandLogo from 'common/components/brand-logo';

const PaymentLayout = () => {
    const token = getToken();
    const navigate = useNavigate();
    if (!token) {
        return <Navigate to="/login" />;
    }
    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                px: [2, 10], // padding-left + padding-right
                py: 2, // padding-top + padding-bottom
            }}
        >
            <BrandLogo width={100} onClick={() => navigate('/')} />
            <Outlet />
        </Box>
    );
};

export default PaymentLayout;
